import { DocumentIcon } from '@heroicons/react/16/solid'
import { ServerAsset } from '@sequencehq/api'
import { Inspector } from '@sequencehq/core-components'
import { GreyGrey70 } from '@sequencehq/design-tokens'
import { Attachments } from 'Assets/Attachments'
import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { useBillingScheduleId } from 'BillingScheduleHome/utils/useBillingScheduleId'
import { useState } from 'react'

const useScheduleAttachments = () => {
  const [attachmentToPreview] = useState<ServerAsset | undefined>()

  const billingScheduleId = useBillingScheduleId()
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId,
    select: data => {
      return {
        attachments: data.billingSchedule.attachmentAssets
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    attachments: billingScheduleAggregateQuery.data?.attachments,
    attachmentToPreview
  }
}
export const BillingScheduleHomeAttachmentsInspectorItem = () => {
  const hook = useScheduleAttachments()

  return (
    <Inspector.IconItem
      data-testid="attachments.inspector.item"
      tooltip="Attachments"
      content={
        <Attachments
          attachmentToPreview={hook.attachmentToPreview}
          initialAttachments={hook.attachments}
          disableModifyAttachments={{
            reason: "Can't add attachments in view mode"
          }}
        />
      }
      icon={<DocumentIcon height="16px" width="16px" color={GreyGrey70} />}
    />
  )
}
